import {
  Feature,
  ISchema,
  PermissionAction,
  PermissionKey,
} from '../../utils/apollo/graphqlSchema';

// this is only for permission control page that only query id and name from Kobol.
export type IBasicSchema = Pick<ISchema, 'id' | 'name'>;

export enum PermissionListType {
  Category = 'CATEGORIES',
  Items = 'ITEMS',
}

export interface IDisplayedPermissionBasic {
  title: string;
  type: PermissionListType;
  requiredFeature?: Feature;
}

export interface IDisplayedPermissionItem extends IDisplayedPermissionBasic {
  type: PermissionListType.Items;
  items: {
    requiredFeature?: Feature;
    actionKey: PermissionAction;
    permissionKeys: PermissionKey[];
  }[];
}

export interface IDisplayedPermissionCategory
  extends IDisplayedPermissionBasic {
  type: PermissionListType.Category;
  list: IDisplayedPermissionItem[];
}
